"use client";

import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { Mail } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
interface ContactItem {
  id: string;
  title: string;
  imgSrc: string;
  imgSrcset: string;
  imgSizes: string;
  imgAlt: string;
  isLogo?: boolean;
}
const departmentList: ContactItem[] = [{
  id: "media",
  title: "MEDIOS DE COMUNICACIÓN",
  imgSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/dept_media_press.png",
  imgSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/dept_media_press.png-wvc-srcset",
  imgSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/dept_media_press.png-wvc-sizes",
  imgAlt: "Equipo de grabación de prensa y medios"
}, {
  id: "executive",
  title: "Director Ejecutivo de Misiones en CR",
  imgSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/dept_executive_leadership.webp",
  imgSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/dept_executive_leadership.webp-wvc-srcset",
  imgSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/dept_executive_leadership.webp-wvc-sizes",
  imgAlt: "Equipo de liderazgo ejecutivo de las Asambleas de Dios"
}, {
  id: "missions",
  title: "Misiones en CR de las AD",
  imgSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/dept_missions_water.png",
  imgSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/dept_missions_water.png-wvc-srcset",
  imgSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/dept_missions_water.png-wvc-sizes",
  imgAlt: "Ministerio de misiones y bautismos"
}, {
  id: "national",
  title: "+50640809890",
  imgSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/dept_national_office_building.webp",
  imgSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/dept_national_office_building.webp-wvc-srcset",
  imgSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/dept_national_office_building.webp-wvc-sizes",
  imgAlt: "Edificio de la sede nacional de las Asambleas de Dios"
}, {
  id: "contributor",
  title: "SERVICIOS AL DONANTE",
  imgSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/dept_contributor_services.png",
  imgSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/dept_contributor_services.png-wvc-srcset",
  imgSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/dept_contributor_services.png-wvc-sizes",
  imgAlt: "Personas orando juntas"
}, {
  id: "gph",
  title: "GOSPEL PUBLISHING HOUSE",
  imgSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/dept_gospel_publishing_house.png",
  imgSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/dept_gospel_publishing_house.png-wvc-srcset",
  imgSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/dept_gospel_publishing_house.png-wvc-sizes",
  imgAlt: "Emblema de Gospel Publishing House",
  isLogo: true
}, {
  id: "publications",
  title: "PUBLICACIONES",
  imgSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/dept_influence_publications.png",
  imgSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/dept_influence_publications.png-wvc-srcset",
  imgSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/dept_influence_publications.png-wvc-sizes",
  imgAlt: "Ejemplares y publicaciones de la revista Influence"
}, {
  id: "digital",
  title: "SERVICIOS DE INTERNET Y CORREO",
  imgSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/dept_digital_services_desk.png",
  imgSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/dept_digital_services_desk.png-wvc-srcset",
  imgSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/dept_digital_services_desk.png-wvc-sizes",
  imgAlt: "Escritorio de trabajo con pantalla y café"
}, {
  id: "agfinancial",
  title: "SERVICIOS FINANCIEROS AG",
  imgSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/dept_ag_financial_brand.webp",
  imgSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/dept_ag_financial_brand.webp-wvc-srcset",
  imgSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/dept_ag_financial_brand.webp-wvc-sizes",
  imgAlt: "Emblema de la marca de servicios financieros AG",
  isLogo: true
}];
export default function Departments() {
  const prefersReducedMotion = useReducedMotion();
  return;
}